import { render } from "./account-group-list.vue?vue&type=template&id=23cc0e3c&scoped=true"
import script from "./account-group-list.vue?vue&type=script&lang=js"
export * from "./account-group-list.vue?vue&type=script&lang=js"

import "./account-group-list.vue?vue&type=style&index=0&id=23cc0e3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cc0e3c"]])

export default __exports__